module.exports = __webpack_public_path__ + "static/wine-and-cheese-b28426ce98ad10f7680b9ee1fdc8d094.jpg";